export const Logo = ({ fill }: React.SVGProps<SVGPathElement>) => (
  <>
    <path d="M93 93H69V163H93V93Z" fill={fill} />
    <path d="M187 93H163V163H187V93Z" fill={fill} />
    <path d="M163 163H93V187H163V163Z" fill={fill} />
    <path d="M163 69H93V93H163V69Z" fill={fill} />
  </>
);
